import { combineReducers } from 'redux'

import {
  // UPDATE_USER_EMAIL,
  // UPDATE_USER_NAME,
  // UPDATE_PASSWORD,
  LOGOUT,
  // UPDATE_GROUP,
  UPDATE_ADMIN_ID,
  TEMP_SET_USER,
  SET_FIREBASE_ROOT,
  SET_PLAY_WAKEUP,
  UPDATE_FACILITY_ID,
  UPDATE_FACILITY_NAME
} from 'actions/user';



import {
  QUERY_PARAM_LOGIN_TYPE,
  QUERY_PARAM_USER_EMAIL,
  QUERY_PARAM_USER_NICKNAME,

  QUERY_PATIENT_NAME,
  QUERY_PATIENT_ROOM_NAME,

  QUERY_CAREGIVER_NAME,


  QUERY_PARAM_START_DATE,
  QUERY_PARAM_START_TIME,
  QUERY_PARAM_END_DATE,
  QUERY_PARAM_END_TIME,
  QUERY_PARAM_EMERGENCY_ROOMID,
  QUERY_PARAM_CHECK_EMERGENCY,
  QUERY_PARAM_CHECK_CAUTION,
  QUERY_PARAM_CHECK_COMPLETED,


  QUERY_PARAM_WAKEUP_START_DATE,
  QUERY_PARAM_WAKEUP_START_TIME,
  QUERY_PARAM_WAKEUP_ROOMID,
  QUERY_PARAM_CHECK_WAKEUP,
  QUERY_PARAM_CHECK_PRESENCE,


  QUERY_SENSOR_QUERY_SENSORID,
  QUERY_SENSOR_QUERY_INSTALLED,
  // QUERY_SENSOR_QUERY_PATIENT ,

  ROOM_QUERY_ROOM_ID,
  ROOM_QUERY_ROOM_NAME,


  QUERY_AUTH_AUTHID,
  QUERY_AUTH_FACILITY_NAME,
} from 'actions/query';


import {
  // ROWS_PER_PAGE_EMERGENCY,
  // ROWS_PER_PAGE_CAUTION,
  // ROWS_PER_PAGE_DEVICE,
  ROWS_PER_PAGE_EMERGENCY_HISTORIES
} from 'actions/rows';


import {
  OPEN_DIALOG,
  SELECTED_DEVICE_ID,
  SELECTED_DEVICE_LABEL,

  SELECT_SLEEP_DEVICE,

  OPEN_DEVICE_SEARCH_DIALOG,
  WHICH_DEVICE
} from 'actions/settings';



//-----------------------------------------
const initEnvSettings = {
  firebaseRootRef : '',
  play_wakeup : 0,
  openDialog: false,

  selected_device_id: '', //이미지 선택용 디바이스
  selected_device_label : '',

  selected_device_for_sleep: [], //수면용으로 선택된 디바이스

  openDeviceSearchDialog: false,
  whichDevice:'',
}

const envSettings = (state = initEnvSettings, action) => {
  switch(action.type){
    case SET_FIREBASE_ROOT:
      return {...state, firebaseRootRef: action.payload}

    case SET_PLAY_WAKEUP:
      return {...state, play_wakeup: action.payload}

    case OPEN_DIALOG:
      return {...state, openDialog: action.payload}

    case SELECTED_DEVICE_ID:
      return {...state, selected_device_id : action.payload}

    case SELECTED_DEVICE_LABEL:
      return {...state, selected_device_label: action.payload}

    case OPEN_DEVICE_SEARCH_DIALOG:
      return {...state, openDeviceSearchDialog: action.payload}

    case WHICH_DEVICE:
      return {...state, whichDevice: action.payload}

    case SELECT_SLEEP_DEVICE:
      return {...state, selected_device_for_sleep: action.payload}

    default:
      return state;
  }
}



const initialState = {
  status: '',
  admin_id: '',
  admin_name :'',
  facility_id : '',
  facility_name : '',
  // userEmail: '',
  // password: '',
  // username:'',
  // group:'',
}


const user = (state = initialState, action) => {

  switch(action.type){
    // case UPDATE_USER_EMAIL:
    //   return {...state, userEmail:action.payload}
    // case UPDATE_USER_NAME:
    //   return {...state, username:action.payload}

    // case UPDATE_PASSWORD:
    //   return {...state, password:action.payload}

    case LOGOUT:
      return action.payload;

    case UPDATE_ADMIN_ID:
      return {...state, admin_id:action.payload}

    case UPDATE_FACILITY_ID:
      return {...state, facility_id:action.payload}

    case UPDATE_FACILITY_NAME:
      return {...state, facility_name:action.payload}

    // case UPDATE_GROUP:
    //   return {...state, group: action.payload}

    case TEMP_SET_USER:
      return action.payload;


    case SET_FIREBASE_ROOT:
      return {...state}

    default:
      return state;
  }
}


const initQuery = {
  queryStatName : '',
  queryStatAddr : '',

  queryLoginType : '',
  queryUserEmail : '',
  queryUserNickname : '',

  queryStartDate : '',
  queryStartTime : '',
  queryEndDate : '',
  queryEndTime : '',
  queryEmergencyRoomId : '',
  queryCheckEmergency : false,
  queryCheckCaution : false,
  queryCheckCompleted: false,


  queryWakeupStartDate: '',
  queryWakeupStartTime: '',
  queryWakeupRoomId: '',
  queryCheckWakeup: false,
  queryCheckPresence: false,

}


const queryParams = (state = initQuery, action) => {

  switch(action.type){

    case QUERY_PARAM_LOGIN_TYPE:
      return {...state, queryLoginType: action.payload}

    case QUERY_PARAM_USER_EMAIL:
      return {...state, queryUserEmail: action.payload}

    case QUERY_PARAM_USER_NICKNAME:
      return {...state, queryUserNickname: action.payload}

    case QUERY_PARAM_START_DATE:
      return {...state, queryStartDate: action.payload}

    case QUERY_PARAM_START_TIME:
      return {...state, queryStartTime: action.payload}

    case QUERY_PARAM_END_DATE:
      return {...state, queryEndDate: action.payload}

    case QUERY_PARAM_END_TIME:
      return {...state, queryEndTime: action.payload}

    case QUERY_PARAM_EMERGENCY_ROOMID:
      return {...state, queryEmergencyRoomId: action.payload}

    case QUERY_PARAM_CHECK_EMERGENCY:
      return {...state, queryCheckEmergency: action.payload}

    case QUERY_PARAM_CHECK_CAUTION:
      return {...state, queryCheckCaution: action.payload}

    case QUERY_PARAM_CHECK_COMPLETED:
      return {...state, queryCheckCompleted: action.payload}

    case QUERY_PARAM_WAKEUP_START_DATE:
      return {...state, queryWakeupStartDate: action.payload}

    case QUERY_PARAM_WAKEUP_START_TIME:
      return {...state, queryWakeupStartTime: action.payload}

    case QUERY_PARAM_WAKEUP_ROOMID:
      return {...state, queryWakeupRoomId: action.payload}

    case QUERY_PARAM_CHECK_WAKEUP:
      return {...state, queryCheckWakeup: action.payload}

    case QUERY_PARAM_CHECK_PRESENCE:
      return {...state, queryCheckPresence: action.payload}

    default:
      return state;
  }
}



const initQueryPatient = {
  patientName : '',
  patientRoomName : '',
}

const queryPatientParams = (state = initQueryPatient, action) => {

  switch(action.type){
    case QUERY_PATIENT_NAME:
      return {...state, patientName: action.payload};

    case QUERY_PATIENT_ROOM_NAME:
      return {...state, patientRoomName: action.payload};

    default:
      return state;
  }

}


/**
 * 요양사 검색 파라미터
 */
const initCareviver = {
  caregiverName : ''
}

const queryCaregiverParams = (state = initCareviver, action) => {
  switch(action.type){
    case QUERY_CAREGIVER_NAME:
      return {...state, caregiverName: action.payload};
    default:
      return state;
  }
}


/**
 * 센서 디바이스 검색창, 검색 파라미터
 */
const initQuerySensor = {
  sensorQuerySensorId : '',
  sensorQueryInstalled : '',
  // sensorQueryPatientName : ''
}


const querySensorParams = (state = initQuerySensor, action) => {

  switch(action.type){

    case QUERY_SENSOR_QUERY_SENSORID:
      return {...state, sensorQuerySensorId: action.payload}

    case QUERY_SENSOR_QUERY_INSTALLED:
      return {...state, sensorQueryInstalled: action.payload}

    // case QUERY_SENSOR_QUERY_PATIENT:
    //   return {...state, sensorQueryPatientName: action.payload}

    default:
      return state;
  }
}


/**
 * 룸 검색창, 검색 파라미터
 */
const initQueryRoom = {
  roomQueryRoomId : '',
  roomQueryRoomName : '',
}

const queryRoomParams = (state = initQueryRoom, action) => {

  switch(action.type){

    case ROOM_QUERY_ROOM_ID:
      return {...state, roomQueryRoomId: action.payload}

    case ROOM_QUERY_ROOM_NAME:
      return {...state, roomQueryRoomName: action.payload}

    default:
      return state;
  }
}


const initQueryAuth = {
  queryAuthAuthID:'',
  queryAuthFacilityName:''
}

const queryAuthParams = (state = initQueryAuth, action) => {

  switch(action.type){
    case QUERY_AUTH_AUTHID:
      return {...state, queryAuthAuthID: action.payload}

    case QUERY_AUTH_FACILITY_NAME:
      return {...state, queryAuthFacilityName: action.payload}

    default:
      return state;
  }
}


/**
 * 각 테이블 Rows per page 값
 */
const initRowsPerPage = {
  // emergencyRowsPerPage : '',
  // cautionRowsPerPage : '',
  // deviceRowsPerPage : '',
  emergencyHistoriesRowsPerPage : '',
}

const queryRowsPerPage = (state = initRowsPerPage, action) => {

  switch(action.type){
    // case ROWS_PER_PAGE_EMERGENCY:
    //   return { ...state, emergencyRowsPerPage: action.payload}

    // case ROWS_PER_PAGE_CAUTION:
    //   return { ...state, cautionRowsPerPage: action.payload}

    // case ROWS_PER_PAGE_DEVICE:
    //   return { ...state, deviceRowsPerPage: action.payload}

    case ROWS_PER_PAGE_EMERGENCY_HISTORIES:
      return { ...state, emergencyHistoriesRowsPerPage: action.payload}

    default:
      return state;

  }
}



const rootReducer = combineReducers({
  envSettings,
  user,
  queryParams,
  queryPatientParams,
  queryCaregiverParams,
  querySensorParams,
  queryRoomParams,
  queryRowsPerPage,
  queryAuthParams,

});

export default rootReducer;

